import { ActionFunctionArgs, LoaderFunction, redirect } from 'react-router-dom'

import type { Category } from '@/apiTypes.ts'
import { selectAppointmentTypePath } from '@/router/paths.ts'

interface LoaderData {
  categories?: Category[]
  loadTime?: number
  error?: string
}

interface ActionData {
  error?: string
}

const action = async ({
  request,
}: ActionFunctionArgs): Promise<ActionData | Response> => {
  const formData = await request.formData()
  const category = formData.get('category') as string

  return redirect(selectAppointmentTypePath({ category }))
}

const loader: LoaderFunction<LoaderData> = async (): Promise<
  LoaderData | Response | null
> => {
  // Return immediately without loading categories
  // Categories will be loaded asynchronously in the component
  return {
    categories: undefined,
    loadTime: 0,
  }
}

export type { ActionData, LoaderData }
export { action, loader }
